import { useEffect, useState } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { Box, Paper, Table, TableBody, TableHead, TableCell, TableContainer, TableRow, TablePagination, CircularProgress } from "@material-ui/core";
import { connect, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core";
import MyUserService from "../../services/myUser";
import { createContacto, updateContacto, deleteContacto, getContactoPorTipoEmail, getTiendaByCliente } from '../../actions/datoscliente'
import { IContactos, ContactoRequest, GetContactosColumns, ContactoDeleteRequest, TipoId } from "./iMisDatos";
import colores from '../../shared/constants/styles';
import Dolar from '../../common/dolar';
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from "@mui/material";
import ContactoDialog from './formularioContacto';

const useStyles = makeStyles({
    table: {
        minWidth: 750,
    },
    paper: {
        width: '100%', 
        mb: 2 
    }
});

const Contactos= (props: any) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { tipoEmailId } = useParams<{ tipoEmailId: string }>();
    const { idSync } = useParams<{ idSync: string }>();
    const location = useLocation<{ tipoEmailNombre: string }>();
    const tipoEmailNombre = location.state?.tipoEmailNombre;
    const [contactos, setContactos] = useState<IContactos[] | null>();
    const [openDialog, setOpenDialog] = useState(false);
    const [error, setError] = useState<string>("");
    const [success, setSuccess] = useState<boolean>(false);
    const [contactoSeleccionado, setContactoSeleccionado] = useState<IContactos | undefined>(undefined);
    const [contactoAEliminar, setContactoAEliminar] = useState<IContactos | null>(null);
    const [openConfirmDelete, setOpenConfirmDelete] = useState<boolean>(false);

    useEffect(() => {
        dispatch(getContactoPorTipoEmail(MyUserService.getMyUser().clienteId, tipoEmailId));
    }, []);

    useEffect(() => {
        setError("");
        if (props.contactoPorTipoEmailResponse) {
            setContactos(props.contactoPorTipoEmailResponse.$values)
        }
    }, [props.contactoPorTipoEmailResponse]);

    useEffect(() => {
        setSuccess(props.successContacto);
        if (props.successContacto && props.contactoResponse.data) {
            dispatch(getContactoPorTipoEmail(MyUserService.getMyUser().clienteId, tipoEmailId));
        }
    }, [props.successContacto]);

    useEffect(() => {
        if(props.error){
            setError(props.error);
        }
    }, [props.error]);
    
    const handleCrearContactos= () => {
        setError("");
        setOpenDialog(true);
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setContactoSeleccionado(undefined);
    };
    
    const handleGuardarContacto = (request: ContactoRequest) => {
        request.tipoEmailId= tipoEmailId;
        request.clienteId= MyUserService.getMyUser().clienteId; 
        request.rolId= MyUserService.getMyUser().tipoRol; 
        setOpenDialog(false);
        setContactoSeleccionado(undefined);
        if(request.contactoId){
            dispatch(updateContacto(request)); 
        } else {
            dispatch(createContacto(request)); 
        }
    };

    const handleEdit = (contacto: IContactos) => {
        setContactoSeleccionado(contacto);
        setOpenDialog(true);
    };

    const handleDelete = (contacto: IContactos) => {
        setContactoAEliminar(contacto);
        setOpenConfirmDelete(true);
    };

    const handleConfirmarEliminacion = () => {
        if (contactoAEliminar) {
            let request: ContactoDeleteRequest= {   
                    contactoId: contactoAEliminar.contactoId,
                    contactoNro: contactoAEliminar.contactoNro
                };
            dispatch(deleteContacto(request)); 
        }
        setOpenConfirmDelete(false);
    };

    const handleCancelarEliminacion = () => {
        setOpenConfirmDelete(false);
        setContactoAEliminar(null);
    };

    return (
        <>
        <div style={{ backgroundColor: colores.grisClaro, overflow: "hidden", clear: "both" }}>
            <Dolar></Dolar>        
            <div className='d-flex justify-content-center'>
                <hr style={{ width: "90%", color: "black" }}></hr>
            </div>
            <div className='d-flex justify-content-between flex-wrap align-items-center' style={{ marginBottom: "0.600rem", paddingRight: "3rem", paddingLeft: "21px" }}>
                <h1 className="fw-bolder" style={{ margin: "1rem 3.5rem" }}>CONFIGURACIÓN DE CORREOS</h1>
            </div>
            <h2 style={{ margin: "1rem 3.5rem", paddingRight: "3rem", paddingLeft: "21px"}}>{tipoEmailNombre}</h2>
        </div>
        <div className='d-flex align-items-end'
            style={{ margin: "1rem 3.5rem", paddingRight: "3rem", paddingLeft: "21px"}}>
            <button 
                type="submit" 
                style={{background: colores.rojo, color: 'white'}} className="btn" onClick={handleCrearContactos}>
                Crear correo
            </button>
        </div>
        { success && 
            <Alert style={{ textAlign: "center", margin: "2vw" }} severity={props.contactoResponse.data? "success": "error"}> {props.contactoResponse.message}</Alert>
        }
        { error &&
            <Alert style={{ textAlign: "center", margin: "2vw" }} severity="error"> {error}</Alert>
        }
        { idSync== TipoId.PortalVentas &&
            <Stack sx={{ margin: "2vw" }}>
                <Alert severity="info">Para este tipo de contacto no se puede editar el email ya que es usado para loguearse en Portal Ventas.</Alert>
            </Stack>
        }
        <div style={{ margin: "2vw" }}>
            <Box sx={{ width: '100%' }}>
                <Paper className={classes.paper}>
                    <TableContainer>
                        {props.loading && 
                            <Box sx={{ display: 'flex',  justifyContent: 'center' }}>
                                <CircularProgress />
                            </Box>
                        }    
                        { contactos && contactos.length <= 0 && 
                            <Stack sx={{ width: '100%', margin: '2vh' }} spacing={2}>
                                <Alert severity="info">No tiene contactos.</Alert>
                            </Stack>
                        }
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                        >
                            <TableHead className="backgroundColor-grey">
                                <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        className={classes.table}
                                    >
                                    {GetContactosColumns(handleEdit, handleDelete).map((column) => (
                                        column.dataKey == "acciones" && idSync.trim() == TipoId.PortalVentas.trim() ?  null : <TableCell className="fontWeight-bold" align="center">{column.label}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {
                                contactos?.map((row: any)=> (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        className={classes.table}
                                    >
                                        {GetContactosColumns(handleEdit, handleDelete).map((column) => (
                                            <TableCell align="center">
                                                {column.dataKey !== 'acciones' ? (
                                                    row[column.dataKey]
                                                ) : (
                                                    column.cellRenderer && idSync.trim() != TipoId.PortalVentas.trim() ? column.cellRenderer({ rowData: row }) : null
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                            ))}                                            
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>
        </div>
        <ContactoDialog
            open={openDialog}
            onClose={handleCloseDialog}
            onGuardar={handleGuardarContacto}
            contacto={contactoSeleccionado}
        />
        <Dialog
            open={openConfirmDelete}
            onClose={handleCancelarEliminacion}
        >
            <DialogTitle>Confirmar eliminación</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    ¿Estás seguro que querés eliminar el contacto {contactoAEliminar?.nombre}?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <button 
                    type="submit" 
                    style={{background: colores.grisOscuro, color: 'white'}} className="btn" onClick={handleCancelarEliminacion}>
                    Cancelar
                </button>
                <button 
                    type="submit" 
                    style={{background: colores.rojo, color: 'white'}} className="btn" onClick={handleConfirmarEliminacion}>
                    Eliminar
                </button>
            </DialogActions>
        </Dialog>
        </>
    );
};

export default connect
(
    (state: any) => ({
        contactoPorTipoEmailResponse: state.datoscliente.contactoPorTipoEmailResponse,
        success: state.datoscliente.success,
        loading: state.datoscliente.loading,
        successContacto: state.datoscliente.successContacto,
        contactoResponse: state.datoscliente.contactoResponse,
        error: state.datoscliente.error
    }),
    dispatch => ({
        getContactoPorTipoEmail: (clienteId: string, tipoEmailId: string)=> dispatch(getContactoPorTipoEmail(clienteId, tipoEmailId)),
        getTiendaByCliente: (clienteId: string)=> dispatch(getTiendaByCliente(clienteId)),
        createContacto: (contactoRequest: ContactoRequest)=> dispatch(createContacto(contactoRequest)),
        updateContacto: (contactoRequest: ContactoRequest)=> dispatch(updateContacto(contactoRequest)),
        deleteContacto: (contactoRequest: ContactoRequest)=> dispatch(deleteContacto(contactoRequest))
    })
)(Contactos);